module.exports = __webpack_public_path__ + "c4760c213de9d3cd5067ef8b400c6964.svg";